
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/platforms/pricing-table-for-webflow",
      function () {
        return require("private-next-pages/help-centre/platforms/pricing-table-for-webflow.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/platforms/pricing-table-for-webflow"])
      });
    }
  